/* eslint-disable default-param-last */
import { combineObjects, getProductName } from "@/utils/normalizers/detailed-product";

const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  /* Detalles del producto */
  GET_DETAILED_PRODUCT: "GET_DETAILED_PRODUCT",
  GET_DETAILED_PRODUCT_SUCCESS: "GET_DETAILED_PRODUCT_SUCCESS",
  GET_DETAILED_PRODUCT_ERROR: "GET_DETAILED_PRODUCT_ERROR",
  /* Color/Capacidad */
  SET_CAPACITY_PRODUCT: "SET_CAPACITY_PRODUCT",
  SET_COLOR_PRODUCT: "SET_COLOR_PRODUCT",
  SET_PRODUCT_SPECS: "SET_PRODUCT_SPECS",
  /* Related devices */
  SET_RELATED_DEVICES: "SET_RELATED_DEVICES"
};

export const initialState = {
  /* Detalles del producto */
  detailedProduct: null,
  detailedProductFetching: false,
  detailedProductError: false,
  /* Capacidad/Color seleccionado */
  capacityProduct: null,
  colorProduct: null,
  nameProduct: null,
  /* Related devices carousel */
  relatedDevices: null
};

const DetailedProduct = (state = initialState, action) => {
  switch (action.type) {

    case HYDRATE: {
      const { device } = action.payload;

      let deviceCombine = combineObjects(state, device);
      // console.log('info', {state, device,deviceCombine})
      return {
        ...state,
        ...deviceCombine,
      };
      // const nextState = combineObjects(state, device);
      // return nextState;
    }
    case types.GET_DETAILED_PRODUCT: {
      return {
        ...state,
        detailedProductFetching: true,
        detailedProductError: false,
      };
    }
    case types.GET_DETAILED_PRODUCT_SUCCESS: {
      const { data } = action.payload;
      const { response, capacityColorName } = data;
      // console.log(response)
      return {
        ...state,
        detailedProduct: response,
        detailedProductFetching: false,
        detailedProductError: false,
        capacityProduct: (capacityColorName && capacityColorName.capacity) || '',
        colorProduct: (capacityColorName && capacityColorName.color) || '',
        nameProduct: (capacityColorName && capacityColorName.name) || ''
      };
    }
    case types.GET_DETAILED_PRODUCT_ERROR: {
      return {
        ...state,
        detailedProductFetching: true,
        detailedProductError: true,
      };
    }
    case types.SET_PRODUCT_SPECS: {
      const { capacityProduct, colorProduct } = action.payload;
      const { detailedProduct } = state;
      const { offers } = detailedProduct;
      const nameProduct = getProductName(capacityProduct, colorProduct, offers);

      return {
        ...state,
        capacityProduct,
        colorProduct,
        nameProduct
      };
    }
    case types.SET_CAPACITY_PRODUCT: {
      const capacityProduct = action.payload.data;
      const { detailedProduct, colorProduct } = state;
      const { offers } = detailedProduct;
      const nameProduct = getProductName(capacityProduct, colorProduct, offers);

      return {
        ...state,
        capacityProduct,
        nameProduct
      };
    }
    case types.SET_COLOR_PRODUCT: {
      const colorProduct = action.payload.data;
      const { detailedProduct, capacityProduct } = state;
      const { offers } = detailedProduct;
      const nameProduct = getProductName(capacityProduct, colorProduct, offers);

      return {
        ...state,
        colorProduct,
        nameProduct
      };
    }
    case types.SET_RELATED_DEVICES: {
      const relatedDevices = action.payload.data;

      return {
        ...state,
        relatedDevices
      };
    }
    default:
      return { ...state };
  }
};

export const actions = {
  /* Detalles del producto */
  getDetailedProduct: (data) => ({
    type: types.GET_DETAILED_PRODUCT,
    payload: { data },
  }),
  getDetailedProductSuccess: (data) => ({
    type: types.GET_DETAILED_PRODUCT_SUCCESS,
    payload: { data },
  }),
  getDetailedProductError: () => ({ type: types.GET_DETAILED_PRODUCT_ERROR }),
  /* Capacidad/Color seleccionado */
  setCapacityProduct: (data) => ({
    type: types.SET_CAPACITY_PRODUCT,
    payload: { data },
  }),
  setColorProduct: (data) => ({
    type: types.SET_COLOR_PRODUCT,
    payload: { data },
  }),
  setProductSpecs: (colorProduct, capacityProduct) => ({
    type: types.SET_PRODUCT_SPECS,
    payload: { colorProduct, capacityProduct },
  }),
  setRelatedDevices: (data) => ({
    type: types.SET_RELATED_DEVICES,
    payload: { data },
  }),
};

export default DetailedProduct;
